export const API_URL = import.meta.env.VITE_API_URL;
export const IMAGE_URL = import.meta.env.VITE_IMAGE_URL;
export const BLANK_URL = import.meta.env.VITE_BLANK_URL;
